module.exports = __webpack_public_path__ + "static/media/map-pin-filled.e57ac493.svg";